// The building kit. A part is stored as [piece, x2, y2, z2, turn, colour]:
// piece and colour are indexes into the lists below, x2/y2/z2 are the position
// in half-metres (so parts snap to a half-metre grid), and turn is 0-3 quarter turns.
// size is [width, height, depth] in metres before turning. price is in FCFA;
// pieces without one are free.
export const PIECES = [
  { id: 'block', name: 'Block', size: [2, 2, 2] },
  { id: 'slab', name: 'Floor', size: [4, 0.5, 4] },
  { id: 'wall', name: 'Wall', size: [4, 3, 0.5] },
  { id: 'window', name: 'Window wall', size: [4, 3, 0.5] },
  { id: 'door', name: 'Door wall', size: [4, 3, 0.5], passable: true },
  { id: 'pillar', name: 'Pillar', size: [0.5, 3, 0.5] },
  { id: 'roof', name: 'Roof slope', size: [4, 1.5, 4] },
  { id: 'step', name: 'Step', size: [2, 0.5, 1] },
  { id: 'fence', name: 'Fence', size: [4, 1, 0.5] },
  { id: 'stall', name: 'Market stall', size: [3, 2.5, 2], passable: true, price: 20000 },
  { id: 'house', name: 'House', size: [8, 3, 7], home: 6, price: 150000 },
  { id: 'tree', name: 'Tree', size: [1, 6, 1] },
  { id: 'lamp', name: 'Street lamp', size: [0.5, 4, 0.5] },
];

export const COLORS = ['#f7eed9', '#f2b705', '#c8402f', '#2f6fb4', '#2f8a56', '#7a5230', '#8d8a86', '#2a2d33', '#e7c4b0', '#cfe0ea'];

export const PLOT = 48; // metres: the side of one plot of land
export const MAX_PLOTS = 6; // plots one player may hold
export const MAX_PARTS = 900; // parts on one plot

export function plotKey(x, z) {
  return `${Math.floor(x / PLOT)}_${Math.floor(z / PLOT)}`;
}

// The ground rectangle a part covers, in metres: { x0, z0, x1, z1 }.
export function footprint(part) {
  const [w, , d] = PIECES[part[0]].size;
  const turned = part[4] % 2 === 1;
  const hw = (turned ? d : w) / 2;
  const hd = (turned ? w : d) / 2;
  const x = part[1] / 2;
  const z = part[3] / 2;
  return { x0: x - hw, z0: z - hd, x1: x + hw, z1: z + hd };
}

// The height of a part's top above sea level, in metres.
export function topOf(part) {
  return part[2] / 2 + PIECES[part[0]].size[1];
}
